import GenericFarmsPage from 'pages/GenericFarms'
import PoolPage from 'pages/Islands/IslandPage/_index'

import { GenericFarmRouteProps, PoolRouteProps } from '.'

export const POOL_ROUTES = [
  {
    path: 'liquidity/pools/:tokenId',
    type: 'pool' as const,
    component: PoolPage as React.ComponentType<PoolRouteProps>,
  },
  {
    path: 'liquidity/farms/single/:farmAddress',
    type: 'farm' as const,
    component: GenericFarmsPage as React.ComponentType<GenericFarmRouteProps>,
  },
]
